export default __webpack_public_path__ + "static/media/exit-icon.c0fb55a9.svg";